<form-popup [(visible)]="visible" (save)="onPopupSaveClick()" (visibleChange)="onVisibleChange($event)" titleText="New Carrier">
    <carrier-form [data]=""></carrier-form>
</form-popup>